import { render, staticRenderFns } from "./chatMange.vue?vue&type=template&id=df951e4c&scoped=true"
import script from "./chatMange.vue?vue&type=script&lang=js"
export * from "./chatMange.vue?vue&type=script&lang=js"
import style0 from "./chatMange.vue?vue&type=style&index=0&id=df951e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df951e4c",
  null
  
)

export default component.exports